import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import moment from "moment";
import {Auth} from "@aws-amplify/auth";
import ApiService from "../../ApiService";
import MaterialTable from 'material-table';
import {Button, Form, Modal} from 'react-bootstrap';
import {Email, Send, Cancel} from "@material-ui/icons";
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import {hideRelevantInfo} from '../../util/licence-util';

import './HomeTable.css';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ActiveCases = ({userProfile}) => {

    let history = useHistory();

    const [assignedTestRequests, setAssignedTestRequests] = useState([]);
    const [assignedTestResults, setAssignedTestResults] = useState([]);
    const [messageModalShow, setMessageModalShow] = useState(false);
    const [messageKitId, setMessageKitId] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackText, setSnackText] = useState('');
    const [snackSeverity, setSnackSeverity] = useState('');

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(() => {
                Auth.currentSession().then(sess => {
                    const tokenId = sess.getIdToken().getJwtToken();
                    const userId = sess.getIdToken().payload.sub;
                    if (tokenId) {
                        async function getAssignedLabRequests() {
                            try {
                                const getAssignedLabRequests = await ApiService.getAssignedLabRequests();
                                const result = getAssignedLabRequests.data.filter(user => user.clinician.userId === userId)
                                setAssignedTestRequests(result);
                            } catch(ex) {
                                console.error(ex);
                            }
                        }
                        getAssignedLabRequests();

                        async function getAssignedLabResults() {
                            try {
                                const getAssignedLabResults = await ApiService.getAssignedLabResults();
                                const result = getAssignedLabResults.data.filter(user => user.clinician.userId === userId)
                                setAssignedTestResults(result);
                            } catch(ex) {
                                console.error(ex);
                            }
                        }
                        getAssignedLabResults();
                    }
                });
            }).catch(err => {
                console.error(err);
            });
    }, []);

    const handleSnackOpen = (text, severity) => {
        setSnackSeverity(severity)
        setSnackText(text)
        setSnackOpen(true);
    };

    const handleSnackClose = () => {
        setSnackOpen(false);
    };

    let myPatients = assignedTestResults;
    let assignedTestResultKitIds = new Set();
    for (let i = 0; i < assignedTestResults.length; i++) {
        assignedTestResultKitIds.add(assignedTestResults[i].kitId)
    }
    for (let i = 0; i < assignedTestRequests.length; i++) {
        if (!assignedTestResultKitIds.has(assignedTestRequests[i].kitId)) {
            myPatients.push(assignedTestRequests[i]);
        }
    }

    myPatients.sort((a, b) => {
        return parseFloat(a.createDateTime) - parseFloat(b.createDateTime)
    })

    myPatients = hideRelevantInfo(myPatients, userProfile?.inValidLicenseStates || []);

    const sendMessage = (message) => {
        handleSnackOpen('Sending Message...', "info")
        async function postPatientMessage() {
            try {
                // eslint-disable-next-line no-unused-vars
                const postPatientMessage = await ApiService.postPatientMessage({"kitId": messageKitId,"message": message});
                handleSnackOpen('Message Sent!', "success")
            } catch(err) {
                console.error(err.message);
                handleSnackOpen(err.message, "error")
            }
        }
        postPatientMessage();
    }

    const handleMessageModalset = (event, rowData) => {
        setMessageKitId(rowData.kitId)
        setMessageModalShow(true)
    }

    return (
        <>
            <MaterialTable
                onRowClick={(event, rowData) => {
                    if(rowData.disableAction) {
                        event.preventDefault();
                        event.stopPropagation();
                        return;
                    }
                    if (rowData.results) {
                        history.push(`/result/${rowData.kitId}`)
                    } else {
                        history.push(`/userrequest/${rowData.kitId}`)
                    }
                }}
                columns={[
                    {title: 'Patient Name', field: 'user.name'},
                    {title: 'Order Id', field: 'kitId'},
                    {title: 'Results Status', field: 'status'},
                    {
                        title: '7-Day Status',
                        field: 'createDateTime',
                        render: rowData => {
                            if (rowData.status === "COMPLETE" || rowData.status === "RESULTS_RELEASED") {
                                return <span>Completed</span>;
                            } else if (rowData.createDateTime) {
                                const d = new Date();
                                const n = moment(d.getTime());
                                const ms = moment(rowData.createDateTime);
                                const days = n.diff(ms, 'days');
                                if ((7 - days) === 0) {
                                    return <span className="text-red">Due Today</span>;
                                } else if (days < 7) {
                                    return (7 - days) + ' day(s) remaining';
                                } else {
                                    return <span className="text-red">{(days - 7)}' day(s) overdue'</span>;
                                }
                            }
                        }
                    },
                ]}
                title="Active cases"
                options={{
                    filtering: false,
                    exportButton: true,
                    headerStyle: {position: 'sticky', top: 0},
                    maxBodyHeight: '400px',
                    search: true,
                    pageSize: 50,
                    pageSizeOptions: [50, 100, 200],
                    emptyRowsWhenPaging: false,
                    actionsColumnIndex: -1,
                    draggable: false,
                }}
                data={myPatients}
                actions={[
                    // {
                    //   icon: () => <AssignmentIndIcon />,
                    //   tooltip: 'Opens Customer Profile in Lab Results',
                    //   onClick: () =>
                    //     <Link to={`/tbd-clinician-sandbox/src/components/LabResult.jsx`}>Go to customer Profile</Link>
                    // },
                    (rowData) => ({
                        icon: () => rowData.disableAction ? <Cancel/> : <Email/>,
                        tooltip: 'Send email to MTL',
                        disabled: rowData.disableAction,
                        onClick: () => {
                            const a = document.createElement('a')
                            a.target = '_blank'
                            a.href = 'mailto:crteam@moleculartestinglabs.com?cc=bthorson@moleculartestinglabs.com, daphne@tbd.health, stephanie@tbd.health'
                            a.click()
                        }
                    }),
                    (rowData) => ({
                        icon: () => rowData.disableAction ? <Cancel/> :<Send/>,
                        disabled: rowData.disableAction,
                        tooltip: 'Message Patient',
                        onClick: (e, row) => handleMessageModalset(e, row)
                    })
                ]}
            />
            <SendMessageModal
                show={messageModalShow}
                onHide={() => setMessageModalShow(false)}
                sendMessage={sendMessage}
            />
            <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert onClose={handleSnackClose} severity={snackSeverity}>
                    {snackText}
                </Alert>
            </Snackbar>
        </>
    )
}

function SendMessageModal(props) {
    const [message, setMessage] = useState("");
    const [addedMessage, setAddedMessage] = useState(false)

    const submitMessageForm = () => {
        setAddedMessage(true)
        if (message !== "") {
            props.sendMessage(message)
            props.onHide();
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body className="onboard-modal">
                <Form id={"sendMessageForm"}>
                    {message === "" && addedMessage &&
                    <p className="text-red">Make sure you add text</p>
                    }
                    <Form.Group controlId="formLink">
                        <Form.Label>Patient Message</Form.Label>
                        <Form.Control as="textarea" rows={5} value={message}
                                      onChange={(e) => setMessage(e.target.value)}/>
                    </Form.Group>
                    <Button className="cancel-button" variant="primary" type="button" onClick={() => props.onHide()}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="button" onClick={() => submitMessageForm()}>
                        Send
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}


export default ActiveCases